<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
    <rect x="4" y="14" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
    <rect x="14" y="14" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
    <rect x="14" y="4" width="6" height="6" rx="1" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
    </svg>
</template>